import React from "react";

// Components
import ContentCard from "../../../../UI/ContentCard/ContentCard";

// Images
import customizeImg from "../../../../assests/images/customize.png";

const ConceptCustomizable = () => (
  <ContentCard
    title="CUSTOMIZABLE CLOTHES"
    id="Customize your clothes"
    image={customizeImg}
    imageTitle="THE MODEL IN FIVE STEPS"
    frontText="On our platform you can easily customize your clothes."
    backTextOne="In our style studio you choose between several style options,
        colors, accessories and add your print design, embroidery and your own brand name.
        You make the design decisions and we take care of the production. Amazing fabrics and
        best quality at reasonable prices for everybody."
    backTextTwo="You can place your own brand on the outside of the garment. SAMPELL is not on the outside. It appears only
        in the inside on a label with production information and laundry instructions."
    backTextThree="In the beginning we will offer casual wear and beach wear. The product range will be hoodies, jackets, vests, body wraps, towels, bathrobes and beach towels. In the further progress we will expand the product range according to the wishes of our customers. "
  />
);

export default ConceptCustomizable;



// WEBPACK FOOTER //
// ./src/components/Pages/Concept/Content/ConceptCustomizable.js